export const chartOptions = {
  colors: ["#094E8D", "#A1A1A1"],
  chart: {
    offsetY: 15,
    width: '100%',
    type: 'bar',
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    show: false,
    categories: ['現在', '過去'],
    labels: {
      formatter: (val: string): string => `${Math.floor(Number(val) / 3600)}:${(`00${Math.floor(Number(val) % 3600)}`).slice(-2)}`,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  legend: {
    show: false,
  },
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
    active: {
      filter: {
        type: 'none',
      },
    },
  },
}

export default chartOptions
